<script>
  let { container } = $props();

  // Condense location / dimensions / material into one scannable line
  const metaLine = $derived(
    [
      container.space?.name,
      container.dimensions,
      [container.material, container.color].filter(Boolean).join(', '),
    ]
      .filter(Boolean)
      .join(' · ')
  );
</script>

<div class="min-w-0">
  {#if metaLine}
    <p class="text-xs text-gray-500 truncate">{metaLine}</p>
  {/if}
  {#if container.notes}
    <p class="text-xs text-gray-400 truncate mt-0.5">{container.notes}</p>
  {/if}
</div>
